import client from '../utils/client';
import { pricesUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const priceService = {
  pricesList,
  addPrice,
  getPrice,
  updatePrice
}

function pricesList() {
  return client.get(pricesUrl)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addPrice(formDate) {
  return client.post(pricesUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getPrice(priceID) {
  return client.get(pricesUrl + '/' + priceID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updatePrice(formDate) {
  return client.post(pricesUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}